module.exports = __webpack_public_path__ + "img/h-telegram.ab4c05a0.svg";